import { useDispatch } from "react-redux";
import { openPopup} from "../../store/popupSlice" 
import Breadcrumb from "../../component/Breadcrumb";

const breadcrumbData = {
  newClass:"center-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"Taxi Software Features",
      slug:"/features/taxi-software"
    },
  ]
}

export default function FeatureNewHead() {
    const dispatch=useDispatch();
  return (
    <>
      <section className="feature-new-head header-gap">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="feature-new-head-content text-center">
                <img src="/assets/home/feature-new-head-vec.webp" alt="vector" className="img-responsive feature-new-head-vec" />
                <Breadcrumb breadcrumbData={breadcrumbData}/>
                <label>FEATURES</label>
                <h1 className="heading"><small>Taxi Booking System Features</small> <span className="gradiant-color">To Automate Your Business</span></h1>
                <p className="sub-heading">Mobility Infotech Taxi Booking System offers everything you need to automate taxi business operations, manage drivers, rides, passengers, & payments.</p>
                <div className="feature-new-head-btns">
                  <button onClick={() => dispatch(openPopup())}  className="default-btn">Start Free Trial</button>
                  {/* <button onClick={() => dispatch(openPopup())}  className="default-white">Book DEMO</button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
